import EmailMsgConfig from './EmailMsgConfig';
export default EmailMsgConfig;
